<mat-accordion multi="true" [hideToggle]="true">
    <mat-expansion-panel class="mat-elevation-z0 consolidated-container" *ngIf="messageGroup && (messageIndex === 1) && !isFirst && !isLast" (click)="handleOpenMessages()">
        <mat-expansion-panel-header>
            <div class="consolidated-thread-label tw-mr-2 tw-p-2">
                {{ thread.messages.length - 2 }}
            </div>
            <hr class="line">
        </mat-expansion-panel-header>
    </mat-expansion-panel>
    <!-- For Marketing Emails -->
    <div *ngIf="message.hubspotEmailTemplateId || message.recipientCount === 0">
        <mat-expansion-panel class="thread-expansion-panel" [expanded]="isLast" (click)="panelOpenState ? handleMessageRead(message) : ''" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
            <mat-expansion-panel-header class="thread-header" [expandedHeight]="'64px'">
                <div class="tw-h-10 tw-w-10 mt-2 mr-4 items-center tw-rounded-full" *ngIf="message.fromEmail.includes('lendio')">
                    <img src="assets/images/favicon.ico" class="tw-h-9 tw-w-9 tw-pt-0.5"> <!-- Lendio Circle Icon-->
                </div>
                <div class="tw-h-10 tw-w-10 tw-pt-2.5 mt-2 mr-4 text-center tw-rounded-full thread-from-icon-background" *ngIf="!message.fromEmail.includes('lendio')">
                    <span>{{ message.fromEmail[0] }}{{ message.fromEmail[1] }}{{ message.fromEmail[2] }}</span> <!-- First three characters of email address -->
                </div>
                <div class="to-from-header">
                    <span *ngIf="message.fromName">{{ message.fromName }}</span>
                    <i id="read-by-header" class="read-by-text" *ngIf="message.hubspotEmailTemplateId">sent: {{ message.date }} {{ message.time }} via Marketing</i>
                    <br>
                    <span class="recipient-footer tw-text-xs" *ngIf="message && message.recipientCount > 0 && panelOpenState"> to {{ message.fromName }}</span>
                </div>
                <div *ngIf="message && message.createdTimestamp">
                    <span class="time-message-created">
                    {{ message?.createdTimestamp * 1000 | date: 'MMMM dd, yyyy, h:mm a' }}
                    </span>
                </div>
            </mat-expansion-panel-header>
            <div class="vertical-left-border">
                <mat-panel-description class="thread-content">
                    <div [innerHTML]="message.hubspotEmailTemplateId ? message.hubspotEmailTemplateId.emailBody : message.html"></div>
                </mat-panel-description>
            </div>
        </mat-expansion-panel>
    </div>
    <!-- End Marketing Emails -->
    <!-- Regular Emails -->
    <div *ngIf="!message.hubspotEmailTemplateId && message.recipientCount > 0">
        <div class="thread-border" *ngIf="!messageGroup || isFirst"></div>
        <mat-expansion-panel class="thread-expansion-panel" [expanded]="isLast" (click)="handleMessageRead(message)" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
            <mat-expansion-panel-header class="thread-header" [expandedHeight]="'64px'" *ngIf="!messageGroup || isFirst || isLast">
                <div class="tw-h-10 tw-w-10 mt-2 mr-4 items-center tw-rounded-full" *ngIf="message.fromEmail.includes('lendio')">
                    <img src="assets/images/favicon.ico" class="tw-h-9 tw-w-9 tw-pt-0.5"> <!-- Lendio Circle Icon-->
                </div>
                <div class="tw-h-9 tw-w-9 tw-pt-2.5 mt-2 mr-4 text-center tw-rounded-full thread-from-icon-background" *ngIf="!message.fromEmail.includes('lendio')">
                    <span>{{ message.fromName[0] }}{{ message.fromName.split(' ').pop()[0] }}</span> <!-- Initials -->
                </div>
                <div class="to-from-header">{{ message.fromName }}
                    <span id="read-by-header" class="read-by-text" *ngIf="message.opened&& message.recipientRecords && message.recipientRecords.length > 0">
                        Read by {{ message.recipientRecords[0].email }} </span>
                    <br>
                    <span class="recipient-footer-preview recipient-footer" *ngIf="message && !panelOpenState" [innerHTML]="message.previewText | truncate: 110"></span>
                    <span class="recipient-footer tw-text-xs" *ngIf="message && message.recipientRecords[0] && panelOpenState"> to {{ message.recipientRecords[0].name }}</span>
                    <mat-icon *ngIf="panelOpenState" [matMenuTriggerFor]="menu" (click)="$event.stopPropagation();" class="gmail-arrow">arrow_drop_down</mat-icon>
                    <mat-menu #menu="matMenu" yPosition="below" class="gmail-menu">
                        <mat-list role="list" *ngIf="message">
                            <mat-list-item role="listItem" class="gmail-menu-item">from:
                                <span class="gmail-menu-item-name">{{ message.fromName }}</span>
                                <span class="gmail-menu-item-val"><{{ message.fromEmail }}></span>
                            </mat-list-item>
                            <mat-list-item role="listItem" class="gmail-menu-item" *ngIf="message.replyEmails">to:
                                <span *ngFor="let toRecipient of message.replyEmails; let finalToRecipient = last;" class="gmail-menu-item-val">
                                    {{ toRecipient.name }} <{{ toRecipient.email }}><span *ngIf="!finalToRecipient">, </span>
                                </span>
                            </mat-list-item>
                            <mat-list-item role="listItem" class="gmail-menu-item" *ngIf="message.bccRecipients && message.bccRecipients.length">bcc:
                                <span *ngFor="let bccRecipient of message.bccRecipients; let finalBccRecipient = last;" class="gmail-menu-item-val">
                                    {{ bccRecipient.name }} <{{ bccRecipient.email }}><span *ngIf="!finalBccRecipient">, </span>
                                </span>
                            </mat-list-item>
                            <mat-list-item *ngIf="message && message.createdTimestamp" role="listItem" class="gmail-menu-item">date:
                                <span class="gmail-menu-item-val">{{ message?.createdTimestamp * 1000 | date: 'MMM d, y, h:mm a' }}</span>
                            </mat-list-item>
                            <mat-list-item role="listItem" class="gmail-menu-item">subject:
                                <span class="gmail-menu-item-val">{{ message.subject }}</span>
                            </mat-list-item>
                        </mat-list>
                    </mat-menu>
                </div>
              <div *ngIf="message.attachments && message.attachments.length" class="attachment-icon"><mat-icon>attachment</mat-icon><span class="tw ml-1 tw-align-super">( {{ message.attachments.length }} )</span></div>
                <div *ngIf="message && message.createdTimestamp">
                    <span class="time-message-created">
                        {{ message?.createdTimestamp * 1000 | date: 'MMMM dd, yyyy, h:mm a' }}
                    </span>
                </div>
            </mat-expansion-panel-header>
            <div class="vertical-left-border">
                <mat-panel-description class="thread-content">
                    <div [innerHTML]="message.html"></div>
                </mat-panel-description>
                <div *ngIf="message.attachments && message.attachments.length > 0" class="button-container">
                    <div *ngFor="let attachment of message.attachments" [ngSwitch]="attachment.filename.split('.').pop()">
                        <button mat-stroked-button class="attachment-button" (click)="downloadAttachment(attachment.id)">
                        <i *ngSwitchCase="'pdf'"><img src="assets/images/pdf-icon.png" class="attachment-button-icon"></i>
                        <i *ngSwitchCase="'csv'"><img src="assets/images/spreadsheet-icon.png" class="attachment-button-icon"></i>
                        <i *ngSwitchCase="'xls'"><img src="assets/images/spreadsheet-icon.png" class="attachment-button-icon"></i>
                        <i *ngSwitchCase="'xlsx'"><img src="assets/images/spreadsheet-icon.png" class="attachment-button-icon"></i>
                        <i *ngSwitchCase="'doc'"><img src="assets/images/doc-icon.png" class="attachment-button-icon"></i>
                        <i *ngSwitchCase="'docx'"><img src="assets/images/doc-icon.png" class="attachment-button-icon"></i>
                        <mat-icon *ngSwitchDefault>insert_drive_file</mat-icon>
                        {{ (attachment.filename.length < 20) ? attachment.filename : (attachment.filename | slice:0:20) + '...' }}
                        </button>
                    </div>
                </div>
                <span *ngIf="message.opened">
                    <span class="read-by-text" *ngIf="message.recipientRecords && message.recipientRecords.length === 1">
                        <span class="read-message">Read</span> by {{ message.recipientRecords[0].email }} <br>
                    </span>
                    <span class="read-by-text" *ngIf="message.recipientRecords && message.recipientRecords.length > 1">
                        <span class="read-message">Read</span> by {{ message.numberOfViews }} of {{ message.recipientRecords.length }} recipients<br>
                    </span>
                </span>
                <div class="forward-reply-buttons" *ngIf="!messageCreateType && isLast">
                    <button mat-raised-button id="reply-button" [disabled]="borrower && (borrower.status === 'dead' || borrower.status === 'doNotContact')" (click)="messageCreateType = 'reply'">Reply</button>
                    <button mat-raised-button id="forward-button" [disabled]="borrower && (borrower.status === 'dead' || borrower.status === 'doNotContact')" (click)="messageCreateType = 'forward'">Forward</button>
                </div>
                <div *ngIf="message.recipientRecords[0]">
                    <div class="rejected-status" *ngIf="message && message.recipientRecords[0].status === 'rejected'">
                        <mat-icon class="rejected-message-icon">warning</mat-icon>
                        <b class="rejected-header">Whoops!</b>
                        <span class="rejected-body"> This message didn't go through. Try verifying and correcting the email: {{ message.recipientRecords[0].email }}</span>
                    </div>
                </div>
            </div>
            <mat-card *ngIf="messageCreateType && borrower && borrower?.status !== 'dead' && borrower?.status !== 'doNotContact'">
                <app-messages-create
                    id="thread-messages-create"
                    [borrower]="borrower"
                    [thread]="thread"
                    [user]="lenderUserFullName"
                    [messageType]="messageCreateType"
                    (emailCreate)="handleEmailCreate($event)"
                    (cancelMessage)="messageCreateType = null">
                </app-messages-create>
            </mat-card>
        </mat-expansion-panel>
    </div>
    <!-- End Regular Emails -->
</mat-accordion>
